import type { UserConfig } from 'next-i18next/pages';
import resourcesToBackend from 'i18next-resources-to-backend';

import { missingKeyHandler } from './src/i18n/missingKeyHandler';
import { loadLocaleResource } from './src/i18n/loadLocaleResource';
import { SUPPORTED_LOCALES, TRANSLATION_NAMESPACES } from './src/i18n/config';

const nextI18NextConfig: UserConfig = {
  i18n: {
    defaultLocale: 'en',
    locales: [...SUPPORTED_LOCALES],
  },
  fallbackLng: false,
  localePath: null,
  ns: [...TRANSLATION_NAMESPACES],
  react: {
    useSuspense: false,
  },
  missingKeyHandler,
  saveMissing: true,
  serializeConfig: false,
  use: [resourcesToBackend(loadLocaleResource)],
};

export default nextI18NextConfig;
